import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSidebarSimpleRightWide: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="sidebar-simple-right-wide"><path fillRule="evenodd" clipRule="evenodd" d="M22 4.75C22 4.33579 21.6642 4 21.25 4H2.75C2.33579 4 2 4.33579 2 4.75V19.25C2 19.6642 2.33579 20 2.75 20H21.25C21.6642 20 22 19.6642 22 19.25V4.75ZM15 5.5V18.5H3.5V5.5H15Z" fill="currentColor"/></CentralIconBase>;
};

export default IconSidebarSimpleRightWide;
